import * as types from "@/store/types";

const state = {
  userVerifyInfo: {}
};

const getters = {
  [types.userVerifyInfo.getters.GET_USER_VERIFY_INFO]: state => {
    return state.userVerifyInfo;
  }
};

const mutations = {
  [types.userVerifyInfo.mutations.MUTATE_USER_VERIFY_INFO]: (
    state,
    payload
  ) => {
    state.userVerifyInfo = payload;
  },

  [types.userVerifyInfo.mutations.MUTATE_PERSONAL_STATUS]: (state, payload) => {
    state.userVerifyInfo = {
      ...state.userVerifyInfo,
      personal_information_status: payload
    };
  },

  [types.userVerifyInfo.mutations.MUTATE_IMAGE_STATUS]: (state, payload) => {
    state.userVerifyInfo = {
      ...state.userVerifyInfo,
      verification_image: {
        ...state.verification_image,
        status: {
          value: payload
        }
      }
    };
  },

  [types.userVerifyInfo.mutations.MUTATE_MOBILE_STATUS]: (state, payload) => {
    state.userVerifyInfo = {
      ...state.userVerifyInfo,
      mobile_verification_status: payload
    };
  },

  [types.userVerifyInfo.mutations.MUTATE_PHONE_STATUS]: (state, payload) => {
    state.userVerifyInfo = {
      ...state.userVerifyInfo,
      home_phone_verification_status: payload
    };
  },

  [types.userVerifyInfo.mutations.MUTATE_EMAIL_STATUS]: (state, payload) => {
    state.userVerifyInfo = {
      ...state.userVerifyInfo,
      email_verification_status: payload
    };
  },

  [types.userVerifyInfo.mutations.MUTATE_MOBILE_VERIFICATION]: (
    state,
    payload
  ) => {
    state.userVerifyInfo = {
      ...state.userVerifyInfo,
      mobile_verification_status: payload
    };
  }
};

const actions = {
  [types.userVerifyInfo.actions.SET_USER_VERIFY_INFO]: (
    { commit },
    payload
  ) => {
    commit(types.userVerifyInfo.mutations.MUTATE_USER_VERIFY_INFO, payload);
  },

  [types.userVerifyInfo.actions.SET_PERSONAL_STATUS]: ({ commit }, payload) => {
    commit(types.userVerifyInfo.mutations.MUTATE_PERSONAL_STATUS, payload);
  },

  [types.userVerifyInfo.actions.SET_IMAGE_STATUS]: ({ commit }, payload) => {
    commit(types.userVerifyInfo.mutations.MUTATE_IMAGE_STATUS, payload);
  },

  [types.userVerifyInfo.actions.SET_MOBILE_STATUS]: ({ commit }, payload) => {
    commit(types.userVerifyInfo.mutations.MUTATE_MOBILE_STATUS, payload);
  },

  [types.userVerifyInfo.actions.SET_PHONE_STATUS]: ({ commit }, payload) => {
    commit(types.userVerifyInfo.mutations.MUTATE_PHONE_STATUS, payload);
  },

  [types.userVerifyInfo.actions.SET_EMAIL_STATUS]: ({ commit }, payload) => {
    commit(types.userVerifyInfo.mutations.MUTATE_EMAIL_STATUS, payload);
  },

  [types.userVerifyInfo.actions.SET_MOBILE_VERIFICATION]: (
    { commit },
    payload
  ) => {
    commit(types.userVerifyInfo.mutations.MUTATE_MOBILE_VERIFICATION, payload);
  }
};
export default { state, getters, mutations, actions };
